import styled from 'styled-components'
import {
  CardBody,
  Heading,
  Flex,
  Skeleton,
  Text,
  Box,
  Button,
  useModal,
  CardRibbon,
  BunnyPlaceholderIcon,
  useMatchBreakpoints,
} from '@pancakeswap/uikit'
import { LotteryRound } from 'state/types'
import { useGetUserLotteriesGraphData, useLottery } from 'state/lottery/hooks'
import { LotteryStatus } from 'config/constants/types'
import { useTranslation } from '@pancakeswap/localization'
import WinningNumbers from '../WinningNumbers'
import ViewTicketsModal from '../ViewTicketsModal'
import { LATEST_LOTTERY_NEW_CONTRACT } from 'state/lottery'

const StyledCardBody = styled(CardBody)`
  position: relative;
  padding: 0;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
`
const Grid = styled.div`
  display: grid;
  grid-template-columns: auto;

  ${({ theme }) => theme.mediaQueries.md} {
    grid-column-gap: 72px;
    grid-row-gap: 36px;
    grid-template-columns: auto 1fr;
  }
`

const StyledCardRibbon = styled(CardRibbon)`
  right: -20px;
  top: -20px;

  ${({ theme }) => theme.mediaQueries.xs} {
    right: -10px;
    top: -10px;
  }
`

const PreviousRoundCardBody: React.FC<
  React.PropsWithChildren<{ lotteryNodeData: LotteryRound; lotteryId: string }>
> = ({ lotteryNodeData, lotteryId }) => {
  const { t } = useTranslation()
  const {
    currentLotteryId,
    currentRound: { status },
  } = useLottery()
  const userLotteryData = useGetUserLotteriesGraphData()
  const isNew = parseInt(LATEST_LOTTERY_NEW_CONTRACT) < parseInt(lotteryId)
  const userDataForRound = userLotteryData.rounds.find((userLotteryRound) => userLotteryRound.lotteryId === (!isNew ? (parseInt(lotteryId) + 2).toString() : lotteryId))
  const { isLg, isXl, isXxl } = useMatchBreakpoints()
  const isLargerScreen = isLg || isXl || isXxl

  const currentLotteryIdAsInt = parseInt(currentLotteryId)
  const mostRecentFinishedRoundId =
    status === LotteryStatus.CLAIMABLE ? currentLotteryIdAsInt : currentLotteryIdAsInt - 1
  const isLatestRound = mostRecentFinishedRoundId.toString() === lotteryId

  const [onPresentViewTicketsModal] = useModal(
    <ViewTicketsModal roundId={lotteryId} roundStatus={lotteryNodeData?.status} />,
  )

  const totalTicketNumber = userDataForRound ? userDataForRound.totalTickets : 0
  const ticketRoundText =
    totalTicketNumber > 1
      ? t('You had %amount% tickets this round', { amount: totalTicketNumber })
      : t('You had %amount% ticket this round', { amount: totalTicketNumber })
  const [youHadText, ticketsThisRoundText] = ticketRoundText.split(totalTicketNumber.toString())

  return (
    <StyledCardBody>
      {/* {isLatestRound && <StyledCardRibbon text={t('Latest')} />} */}
      <Flex flexDirection='column' width='100%'>
        <Flex flexDirection='column'>
            <Flex justifyContent='center'>
              <Text mb="30px" mt='60px' fontSize='18px'>{t('Winning numbers')}</Text>
            </Flex>
          <Flex mb='60px' justifyContent='center'>
            {lotteryId ? (
              lotteryNodeData?.finalNumber ? (
                <WinningNumbers
                  rotateText={isLargerScreen || false}
                  number={lotteryNodeData?.finalNumber.toString()}
                  size={isLargerScreen ? "60" : "40"}
                  fontSize={isLargerScreen ? '32' : '20'}
                />
              ) : (
                <Skeleton
                  width={['240px', null, null, '450px']}
                  height={['34px', null, null, '71px']}
                />
              )
            ) : (
              <>
                <Flex flexDirection="column" alignItems="center" width={['240px', null, null, '480px']}>
                  <Text mb="8px">{t('Please specify Round')}</Text>
                  {/* <BunnyPlaceholderIcon height="64px" width="64px" /> */}
                </Flex>
              </>
            )}
          </Flex>
        </Flex>
        
        {userDataForRound && isNew && (
          <>
            <Flex
              p='20px'
              style={{borderTop: '1px solid rgba(255,255,255,0.07)'}}
              width="100%"
              alignItems='center'
              justifyContent='space-between'
            >
              <Box py='20px'>
                <Text display="inline">{youHadText} </Text>
                <Text display="inline" bold>
                  {userDataForRound.totalTickets}
                </Text>
                <Text display="inline">{ticketsThisRoundText}</Text>
              </Box>
              <Button
                onClick={onPresentViewTicketsModal}
                height="auto"
                width="fit-content"
                p="0"
                variant="secondary"
                scale="sm"
                style={{padding: '15px 20px 16px 20px', fontSize: '18px', height: '44px'}}
              >
                {t('View your tickets')}
              </Button>
            </Flex>
          </>
        )}
      </Flex>
    </StyledCardBody>
  )
}

export default PreviousRoundCardBody
